import { LoginClientManager } from "@tlc/ls2pac/app/ClientManagers/LoginClientManager";
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const LoginPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    const search = new URLSearchParams(location.search);
    const to = search.get("from");
    const redirectUrl = to || "/myaccount/summary"; // if no "to" provided, load account summary on login
    LoginClientManager.promptIfNotLoggedIn(
      () => {
        return navigate(redirectUrl, { replace: true }); // remove /login from history
      },
      () => {
        // TODO set the refering URL in case the user cancels 
        navigate("/", { replace: true }); 
      },
      `/#${redirectUrl}?`
    );
  }, []);

  return <></>;
};
